import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/non-controlled-hitter-stacking/actions';

class ChooseTeamsRandomly extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.setTeamsAreChosenRandomly(isChecked));
    }

    render() {
        const {stacking} = this.props;
        const isChecked = stacking.isTeamsChosenRandomly();

        return (
            <label>
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
                Randomly select teams
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;
    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(ChooseTeamsRandomly);
